exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notfound[data-v-94fca950]{position:relative;max-width:600px;height:auto;margin:0 0 16px}.notfound .left-slider-right[data-v-94fca950]{margin:36px 0 16px}@media (max-width:576px){.notfound .left-slider-right[data-v-94fca950]{margin:32px 0 16px}}.notfound .left-slider-right .notfound-content[data-v-94fca950]{padding:10px;border:1px solid #9994c2;max-width:100%}.notfound .left-slider-right .notfound-content h2[data-v-94fca950]{width:100%;text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-94fca950","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/notfound.vue
// module id = 685
// module chunks = 0